import { Form, Slider, Switch, TimePicker } from 'antd';
import { SliderMarks } from 'antd/es/slider';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import {
  calculatePlusTimeDifference,
  calculateTimeDifference,
} from 'utils/common_function';

const marks: SliderMarks = {
  0: 'Rest',
  50: 'Working',
  100: 'Business',
};

type Props = {
  addData?: (data) => void;
  finalData: any;
  check?: boolean;
};

const weekday = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const DayWorkedTable = ({ addData, finalData, check }: Props) => {
  const [state, setState] = useState({
    days: null,
  });
  const { days } = state;
  const format = 'HH:mm';
  const formik = useFormik({
    initialValues: finalData,
    onSubmit: (data) => {
      // addData(data);
    },
  });

  const changeLeaveManagement = (week_day: number, value: number) => {
    setState((pre) => ({
      ...pre,
      days: {
        ...days,
        workshift_days: (days as any)?.workshift_days?.map((item: any) => {
          if (week_day === item.week_day) {
            return {
              ...item,
              leave_management:
                value === 0 ? 'rest' : value === 50 ? 'working' : 'business',
              is_active: value === 0 ? false : true,
              workshift_1_active: value === 0 ? false : true,
              workshift_2_active: value === 0 ? false : true,
            };
          } else {
            return {
              ...item,
            };
          }
        }),
      },
    }));
  };

  const onChangeStatus = (week_day: number, type_time: string) => {
    setState((pre) => ({
      ...pre,
      days: {
        ...days,
        workshift_days: days?.workshift_days?.map((item) => {
          if (week_day === item.week_day) {
            switch (type_time) {
              case 'workshift_1_active':
                return {
                  ...item,
                  workshift_1_active: !item.workshift_1_active,
                };
              case 'workshift_2_active':
                return {
                  ...item,
                  workshift_2_active: !item.workshift_2_active,
                };
              default:
                return item;
            }
          } else {
            return {
              ...item,
            };
          }
        }),
      },
    }));
  };

  const onChangeLeaveManagement = (
    time: string,
    week_day: number,
    type_time: string,
  ) => {
    setState((pre) => ({
      ...pre,
      days: {
        ...days,
        workshift_days: days?.workshift_days?.map((item) => {
          if (week_day === item.week_day) {
            switch (type_time) {
              case 'workshift_1_start_time':
                return {
                  ...item,
                  workshift_1_start_time: time,
                };
              case 'workshift_1_end_time':
                return {
                  ...item,
                  workshift_1_end_time: time,
                };
              case 'workshift_2_start_time':
                return {
                  ...item,
                  workshift_2_start_time: time,
                };
              case 'workshift_2_end_time':
                return {
                  ...item,
                  workshift_2_end_time: time,
                };
              default:
                return item;
            }
          } else {
            return {
              ...item,
            };
          }
        }),
      },
    }));
  };
  useEffect(() => {
    addData?.(days);
  }, [days]);

  useEffect(() => {
    setState((pre) => ({
      ...pre,
      days: finalData,
    }));
  }, [finalData]);
  //
  // let x = null;

  return (
    <Form onFinish={formik.handleSubmit}>
      {days?.workshift_days?.map((item, index: number) => (
        <div
          key={index}
          style={{
            display: 'flex',
            width: '100%',
            opacity:
              item.leave_management === 'rest' ||
              check ||
              (!item.workshift_1_active && !item.workshift_2_active)
                ? '0.5'
                : '',
          }}
        >
          <div
            style={{
              width: '20%',
              display: 'flex',
              alignItems: 'center',
              paddingLeft: '7.5%',
              gap: 10,
              height: 50,
            }}
          >
            {/* <Checkbox
              checked={item.leave_management === 'rest' ? false : true}
              onChange={() => changeActive(item.week_day)}
            /> */}
            {weekday[index]}
          </div>
          <div
            style={{
              width: '25%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 50,
            }}
          >
            <Switch
              onChange={(e) => {
                if (item.leave_management === 'rest' && e) {
                  item.leave_management = 'working';
                }
                onChangeStatus(item.week_day, 'workshift_1_active');

                if (e === false && !item.workshift_2_active) {
                  item.leave_management = 'rest';
                }
              }}
              checked={
                item.leave_management === 'rest'
                  ? false
                  : item?.workshift_1_active
              }
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '5px',
              }}
            >
              <TimePicker
                style={{
                  width: 40,
                  color: 'rgba(0, 0, 0, 1)',
                  paddingRight: 0,
                  paddingLeft: 0,
                }}
                showNow={false}
                // bordered={false}
                // onSelect={(s) => {
                //   x = s;
                // }}
                onChange={(v, s: string) => {
                  onChangeLeaveManagement(
                    s,
                    item.week_day,
                    'workshift_1_start_time',
                  );
                }}
                allowClear={false}
                onCalendarChange={(value) => {
                  item.workshift_1_start_time = dayjs(value as any).format(
                    'HH:mm',
                  );
                }}
                needConfirm={false}
                bordered={false}
                suffixIcon={null}
                value={dayjs(item.workshift_1_start_time, 'HH:mm')}
                format={format}
                use12Hours={false}
                disabledTime={(current) => {
                  if (current) {
                    const workshift1EndTime = item.workshift_1_end_time;
                    const workshift1StartTime = item.workshift_1_start_time;

                    const endTimeParts = workshift1EndTime.split(':');
                    const startTimeParts = workshift1StartTime.split(':');

                    const endHour = parseInt(endTimeParts[0], 10);
                    const startHour = parseInt(startTimeParts[0], 10);

                    const hours = Array.from({ length: 24 }, (_, i) => i);
                    const disabledHours = hours.slice(endHour + 1, 24);

                    const endMinute = parseInt(endTimeParts[1], 10);

                    const disabledMinutes =
                      endHour === startHour
                        ? Array.from({ length: 60 }, (_, i) => i).slice(
                            endMinute,
                            60,
                          )
                        : [];

                    return {
                      disabledHours: () => disabledHours,
                      disabledMinutes: () => disabledMinutes,
                    };
                  }
                  return {};
                }}
              />
              -
              <TimePicker
                style={{
                  width: 40,
                  color: 'rgba(0, 0, 0, 1)',
                  paddingRight: 0,
                  paddingLeft: 0,
                }}
                showNow={false}
                bordered={false}
                onCalendarChange={(value: any) => {
                  item.workshift_1_end_time = dayjs(value).format('HH:mm');
                }}
                needConfirm={false}
                onChange={(v, s: string) => {
                  onChangeLeaveManagement(
                    s,
                    item.week_day,
                    'workshift_1_end_time',
                  );
                }}
                suffixIcon={null}
                allowClear={false}
                value={dayjs(item.workshift_1_end_time, 'HH:mm')}
                format={format}
                use12Hours={false}
                disabledTime={(current) => {
                  if (current) {
                    const workshift1StartTime = item.workshift_1_start_time;
                    const workshift1EndTime = item.workshift_1_end_time;

                    const startTimeParts = workshift1StartTime.split(':');
                    const endTimeParts2 = workshift1EndTime.split(':');

                    const startHour = parseInt(startTimeParts[0], 10);
                    const endHour = parseInt(endTimeParts2[0], 10);

                    const startMinute = parseInt(startTimeParts[1], 10);

                    const disabledMinutes =
                      endHour === startHour
                        ? Array.from({ length: 60 }, (_, i) => i).slice(
                            0,
                            startMinute + 1,
                          )
                        : [];

                    const hours = Array.from({ length: 24 }, (_, i) => i);
                    const disabledHours = hours
                      .slice(0, startHour)
                      .concat(hours.slice(13, 24));

                    return {
                      disabledHours: () => disabledHours,
                      disabledMinutes: () => disabledMinutes,
                    };
                  }
                  return {};
                }}
              />
            </div>
            <div style={{ color: '#282828', fontSize: '12px' }}>
              {calculateTimeDifference(
                item.workshift_1_start_time,
                item.workshift_1_end_time,
              ) === '0'
                ? '0:00'
                : calculateTimeDifference(
                    item.workshift_1_start_time,
                    item.workshift_1_end_time,
                  )}
            </div>
          </div>
          <div
            style={{
              width: '25%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 50,
            }}
          >
            <Switch
              onChange={(e) => {
                if (item.leave_management === 'rest' && e) {
                  item.leave_management = 'working';
                }

                if (e === false && !item.workshift_1_active) {
                  item.leave_management = 'rest';
                }

                onChangeStatus(item.week_day, 'workshift_2_active');
              }}
              checked={
                item.leave_management === 'rest'
                  ? false
                  : item?.workshift_2_active
              }
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '5px',
              }}
            >
              <TimePicker
                style={{
                  width: 40,
                  color: 'rgba(0, 0, 0, 1)',
                  paddingRight: 0,
                  paddingLeft: 0,
                }}
                showNow={false}
                bordered={false}
                onChange={(v, s: string) => {
                  onChangeLeaveManagement(
                    s,
                    item.week_day,
                    'workshift_2_start_time',
                  );
                }}
                onCalendarChange={(value: any) => {
                  item.workshift_2_start_time = dayjs(value).format('HH:mm');
                }}
                needConfirm={false}
                suffixIcon={null}
                allowClear={false}
                value={dayjs(item.workshift_2_start_time, 'HH:mm')}
                use12Hours={false}
                format={format}
                disabledTime={(current) => {
                  if (current) {
                    const workshift2EndTime = item.workshift_2_end_time;
                    const workshift2StartTime = item.workshift_2_start_time;

                    const workshift1EndTime = item.workshift_2_start_time;

                    const endTimeParts = workshift2EndTime.split(':');
                    const startTimeParts = workshift2StartTime.split(':');

                    const endHour = parseInt(endTimeParts[0], 10);
                    const startHour = parseInt(startTimeParts[0], 10);

                    const endMinute = parseInt(endTimeParts[1], 10);

                    const disabledMinutes =
                      endHour === startHour
                        ? Array.from({ length: 60 }, (_, i) => i).slice(
                            endMinute,
                            60,
                          )
                        : [];

                    const hours = Array.from({ length: 24 }, (_, i) => i);
                    const disabledHours = hours
                      .slice(endHour + 1, 24)
                      .concat(hours.slice(0, 13));

                    return {
                      disabledHours: () => disabledHours,
                      disabledMinutes: () => disabledMinutes,
                    };
                  }
                  return {};
                }}
              />
              -
              <TimePicker
                style={{
                  width: 40,
                  color: 'rgba(0, 0, 0, 1)',
                  paddingRight: 0,
                  paddingLeft: 0,
                }}
                showNow={false}
                bordered={false}
                onChange={(v, s: string) => {
                  onChangeLeaveManagement(
                    s,
                    item.week_day,
                    'workshift_2_end_time',
                  );
                }}
                suffixIcon={null}
                allowClear={false}
                onCalendarChange={(value: any) => {
                  item.workshift_2_end_time = dayjs(value).format('HH:mm');
                }}
                needConfirm={false}
                value={dayjs(item.workshift_2_end_time, 'HH:mm')}
                format={format}
                disabledTime={(current) => {
                  if (current) {
                    const workshift2StartTime = item.workshift_2_start_time;
                    const workshift2EndTime = item.workshift_2_end_time;

                    const startTimeParts = workshift2StartTime.split(':');
                    const endTimeParts2 = workshift2EndTime.split(':');

                    const startHour = parseInt(startTimeParts[0], 10);
                    const endHour = parseInt(endTimeParts2[0], 10);

                    const startMinute = parseInt(startTimeParts[1], 10);

                    const disabledMinutes =
                      endHour === startHour
                        ? Array.from({ length: 60 }, (_, i) => i).slice(
                            0,
                            startMinute + 1,
                          )
                        : [];
                    const hours = Array.from({ length: 24 }, (_, i) => i);

                    return {
                      disabledHours: () => hours.slice(0, startHour),

                      disabledMinutes: () => disabledMinutes,
                    };
                  }
                  return {};
                }}
              />
            </div>
            <div style={{ color: '#282828', fontSize: '12px' }}>
              {' '}
              {calculateTimeDifference(
                item.workshift_2_start_time,
                item.workshift_2_end_time,
              ) === '0'
                ? '0:00'
                : calculateTimeDifference(
                    item.workshift_2_start_time,
                    item.workshift_2_end_time,
                  )}
            </div>
          </div>
          <div
            style={{
              width: '10%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 20,
            }}
          >
            <span>
              {!item?.workshift_1_active && !item?.workshift_2_active
                ? '0:00'
                : !item.workshift_2_active
                ? calculateTimeDifference(
                    item.workshift_1_start_time,
                    item.workshift_1_end_time,
                  )
                : !item.workshift_1_active
                ? calculateTimeDifference(
                    item.workshift_2_start_time,
                    item.workshift_2_end_time,
                  )
                : calculatePlusTimeDifference(
                    calculateTimeDifference(
                      item.workshift_1_start_time,
                      item.workshift_1_end_time,
                    ),
                    calculateTimeDifference(
                      item.workshift_2_start_time,
                      item.workshift_2_end_time,
                    ),
                  )}
            </span>
          </div>
          <div
            style={{
              width: '15%',
            }}
          >
            <Slider
              onChange={(v) => changeLeaveManagement(item.week_day, v)}
              trackStyle={{ background: '#407FDD' }}
              className="custom-slider"
              marks={marks}
              included
              step={null}
              value={
                !item?.workshift_1_active && !item?.workshift_2_active
                  ? 0
                  : item.leave_management === 'rest'
                  ? 0
                  : item.leave_management === 'working'
                  ? 50
                  : 100
              }
            />
          </div>
        </div>
      ))}
    </Form>
  );
};

export default DayWorkedTable;
